/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTAuNSAwLjVWMTUuNUgxNS41VjAuNUgwLjVaTTEuNSAxLjVIMTQuNVY2LjVIMS41VjEuNVpNMS41IDE0LjVWNy41SDE0LjVWMTQuNUgxLjVaTTggMy41SDNWNC41SDhWMy41Wk0xMSAzLjVIMTNWNC41SDExVjMuNVoiIGZpbGw9ImJsYWNrIi8+PC9zdmc+";